import Cv from './sub-components/Cv';
import NiveauEtude from './sub-components/NiveauEtude';
import Salarie from './sub-components/Salarie';
import { Col, Row } from 'reactstrap';
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
    dataLayer: {
        'event': 'eni_InformationCandidat'
    },
    dataLayerName: 'PageDataLayer'
}
const Candidat = ({ prevStep, nextStep, handleChange, values, civilites, situations, niveauxEtude, handleErreur, CodeTypeJourneeInformation }) => {

    const getCivilite = () => {
        return civilites.map((civilite) => {
            return <option value={civilite.id}>{civilite.libelle}
            </option>;
        });
    }
    const getSituation = () => {
        return situations.map((situation) => {
            return <option value={situation.id}>{situation.libelle}
            </option>;
        });
    }
    const Continue = e => {
        e.preventDefault();
        nextStep();
    }
    const Previous = e => {
        e.preventDefault();
        prevStep();
    }
    TagManager.dataLayer(tagManagerArgs)
    return (
        <div>
            <h1 className="mb-4 color-green-eni spinnaker text-center fs-32">Vos informations</h1>
            <Row className="mb-4" >
                <Col sm="3">
                    <div class="d-flex flex-column">
                        <label>Civilité*</label>
                        <select
                            type="text"
                            value={values.idCivilite}
                            onChange={handleChange('idCivilite')}
                            id="idCivilite"
                        >
                            <option value="0" selected="selected"></option>
                            {getCivilite()}
                        </select>
                        {handleErreur('idCivilite')}
                    </div>
                </Col>
                <Col sm="5" className="mt-sm-0 mt-4">
                    <div class="d-flex flex-column">
                        <label>NOM*</label>
                        <input type="text" id="nom" value={values.nom} onChange={handleChange('nom')} maxLength="80" />
                        {handleErreur('nom')}
                    </div>
                </Col>
                <Col sm="4" className="mt-sm-0 mt-4">
                    <div class=" d-flex flex-column">
                        <label>Prénom*</label>
                        <input type="text" id="prenom" value={values.prenom} onChange={handleChange('prenom')} maxLength="80" />
                        {handleErreur('prenom')}
                    </div>
                </Col>
            </Row>
            <Row className="mb-4">
                <Col sm="3">
                    <div class="d-flex flex-column">
                        <label>Adresse*</label>
                        <input type="text" id="adress" value={values.adress} onChange={handleChange('adress')} maxLength="80" />
                        {handleErreur('adress')}
                    </div>
                </Col>
                <Col sm="4" className="mt-sm-0 mt-4">
                    <div class="d-flex flex-column">
                        <label>Code Postal*</label>
                        <input type="number" id="codepostal" value={values.codepostal} onChange={handleChange('codepostal')} maxLength="5" />
                        {handleErreur('codepostal')}
                    </div>
                </Col>
                <Col sm="5" className="mt-sm-0 mt-4">
                    <div class="d-flex flex-column">
                        <label>Ville*</label>
                        <input type="text" id="ville" value={values.ville} onChange={handleChange('ville')} maxLength="80" />
                        {handleErreur('ville')}
                    </div>
                </Col>
            </Row>
            <Row className="mb-4">
                <Col sm="3">
                    <div class="d-flex flex-column">
                        <label>Date de Naissance*</label>
                        <input type="date" id="naissance" value={values.naissance} onChange={handleChange('naissance')} />
                        {handleErreur('naissance')}
                    </div>
                </Col>
                <Col sm="4" className="mt-sm-0 mt-4">
                    <div class="d-flex flex-column">
                        <label>Téléphone*</label>
                        <input type="text" id="telephone" value={values.telephone} onChange={handleChange('telephone')} maxLength="20" />
                        {handleErreur('telephone')}
                    </div>
                </Col>
                <Col sm="5" className="mt-sm-0 mt-4">
                    <div class="d-flex flex-column">
                        <label>Email*</label>
                        <input type="mail" id="mail" value={values.mail} onChange={handleChange('mail')} maxLength="80" />
                        {handleErreur('mail')}
                    </div>
                </Col>
            </Row>
            <Row className="mb-1">
                <Col sm="3">
                    <div class="d-flex flex-column">
                        <label>Situation*</label>
                        {CodeTypeJourneeInformation == 1? (
                            // Affiche la zone de texte si CodeTypeJourneeInformation est 1 
                            <input
                                type="text"
                                value="Etudiant.e"
                                readOnly
                                id="idSituation"
                                class="opacity-50"
                            />
                        ) : (
                            // Sinon, affiche le select avec les options
                            <select
                                type="text"
                                value={values.idSituation} 
                                onChange={handleChange('idSituation')}
                                id="idSituation"
                            >
                                <option value="0" selected="selected"></option>
                                {getSituation()}
                            </select>)}
                        {handleErreur('idSituation')}
                    </div>
                </Col>
                <Col sm="9" className="">
                    <NiveauEtude
                        values={values}
                        niveauxEtude={niveauxEtude}
                        handleChange={handleChange}
                        handleErreur={handleErreur}
                    />
                    <Salarie
                        values={values}
                        handleChange={handleChange}
                    />
                </Col>
            </Row>
            <Row className="mb-3">
                <Col sm="6" className="mt-sm-0 mt-4">
                    <span class="mt-3 mb-3 fw-semibold color-blue-dark-eni spinnaker fs-16">Votre CV</span>
                    <div class="d-flex flex-row-reverse justify-content-end align-items file-upload">
                        <label class="mx-custom-10" for="displayCv">Je dépose mon CV</label>
                        <input type="checkbox" checked={values.displayCv ? "checked" : ""} name="displayCv" id="updloadCV" onChange={handleChange('displayCv')} />
                    </div>
                    <div className="file-upload openSans fw-semibold">
                        <Cv
                            values={values}
                            handleChange={handleChange}
                            handleErreur={handleErreur}
                        />
                    </div>
                </Col>
                {/*<Col sm="6"> COMMENTAIRE 0 RETIRER LE JOUR Où ON GERERA LA LETTRE DE MOTIVATION (RIEN D'AUTRE à FAIRE)
                <span class="mt-3 mb-3 fw-semibold color-blue-dark-eni spinnaker fs-16">Votre lettre de motivation</span>
                <div class="d-flex flex-row-reverse justify-content-end align-items file-upload">
                    <label class="mx-custom-10" for="displayCv">Je dépose ma lettre de motivation</label>
                    <input type="checkbox" checked={values.displayLettre ? "checked" : ""} name="displayLettre" id="updloadLettre" onChange={handleChange('displayLettre')} />
                </div>
                <div className="file-upload openSans fw-semibold">
                    <Lettre
                        values={values}
                        handleChange={handleChange}
                        handleErreur={handleErreur}
                    />
                </div>
            </Col>*/}
            </Row>

            <div class="mb-5  d-flex justify-content-between">
                <button class="btn-outline-green-eni border-outline-green-eni fs-20 lh-15 p-3" onClick={Previous}>Précédent</button>
                <button class="btn-outline-green-eni border-outline-green-eni fs-20 lh-15 p-3" onClick={Continue}>Valider</button>
            </div>
            <span class="color-grey-light-eni fs-12">* Les champs précédés d'un astérisque sont obligatoires</span>
        </div>

    )
}

export default Candidat